import Endpoints from 'constants/Endpoints';
import RestRequest, {RestRequestGET} from 'libs/RestRequest';
import reduxStore from 'redux/store'
import {clearResource, setResource} from "../redux/actions";

const VALID_EXTENSIONS_LIST_RESOURCE_ID = "validExtensionsList"

const upload = async (
    file,
    onUploadChange = () => {
    },
    url,
    encryptRoundId) => {

    if (!url) {
        let auth = JSON.parse(localStorage.getItem("authorize"));
        url = Endpoints.UPLOAD(auth.csrf, encryptRoundId);
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
        return await RestRequest({
            method: 'post',
            data: formData,
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: onUploadChange
        })
    } catch (error) {
        throw error.data
    }

}

const getValidExtensions = async () => {
    try {
        const extensions = await RestRequestGET(Endpoints.extensions());
        reduxStore.dispatch(setResource(VALID_EXTENSIONS_LIST_RESOURCE_ID, extensions))
    } catch (e) {
        console.error(e);
    }
}
const clearValidExtensionsResource = () => {
    reduxStore.dispatch(clearResource(VALID_EXTENSIONS_LIST_RESOURCE_ID));
}

export default {
    upload,
    getValidExtensions,
    clearValidExtensionsResource,
    VALID_EXTENSIONS_LIST_RESOURCE_ID
};